import { createContext, useContext, useEffect, useState } from "react";
import { fetchSiteSettings, getSiteSettings } from "../utils/siteSettings";

const SiteSettingsContext = createContext(getSiteSettings());

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(getSiteSettings);

  useEffect(() => {
    fetchSiteSettings().then((s) => {
      if (s) setSettings(s);
    });
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
